import { render, staticRenderFns } from "./ExtraEquipmentInPackage.vue?vue&type=template&id=b30804f8&"
import script from "./ExtraEquipmentInPackage.vue?vue&type=script&lang=js&"
export * from "./ExtraEquipmentInPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports